import { createSlice } from '@reduxjs/toolkit';

export const PLANT_CONFIG_KEY = 'plantConfig';

type ComponentState = {
  plantCode: string;
  plantSupportsCarrierConfiguration: boolean;
};

const initialComponentState: ComponentState = {
  plantCode: '',
  plantSupportsCarrierConfiguration: true,
};

export const componentsSlice = createSlice({
  name: 'components',
  initialState: initialComponentState,
  reducers: {
    plantSelected: (state, action) => {
      state.plantCode = action.payload.plantCode;
      state.plantSupportsCarrierConfiguration =
        action.payload.plantSupportsCarrierConfiguration;
    },
  },
});
